import { Routes } from '@angular/router';

/**
 * 통합 포털 레이아웃 관리 라우트 (Phase 2).
 *
 * 기존 partner-portal-layout / customer-portal-layout / marketer-portal-layout
 * 3개 분리 페이지를 1개 페이지 + 3-탭 으로 통합.
 *
 * @see projects/admin/docs/portal-layout-redesign/master-plan.md (Phase 2)
 * @see docs/portal-layout-redesign/spec/mockups/portal-layout-admin-v2.html
 */
export const portalLayoutRoutes: Routes = [
  {
    path: '',
    data: { mainLayoutNoPadding: true },
    loadComponent: () =>
      import(
        './components/smart/portal-layout-page/portal-layout-page.component'
      ).then((m) => m.PortalLayoutPageComponent),
  },
  // Phase 3 — 메뉴 페이지 에디터
  // /portal-layout/{layoutId}/menu/{menuKey}/page-editor
  {
    path: ':layoutId/menu/:menuKey/page-editor',
    data: { mainLayoutNoPadding: true },
    loadComponent: () =>
      import(
        './components/smart/portal-page-editor-page/portal-page-editor-page.component'
      ).then((m) => m.PortalPageEditorPageComponent),
  },
];
